import { Component, computed, input, ChangeDetectionStrategy } from "@angular/core";
import { EligibilityRule } from "./eligibility-view.compoent";
import { UIBadgeModule } from "@fry/ui/badge";
import { UIBadgeVariant } from "@fry/ui/badge/badge.component";

type BadgeProps = {
    variant: UIBadgeVariant,
    icon?: string;
};

@Component({
    selector: 'eas-eligibility-view-rule',
    templateUrl: 'eligibility-view-rule.component.html',
    imports: [UIBadgeModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./eligibility-view-rule.component.css']
})
export class EligibilityViewRuleComponent {

    eligibility = input.required<EligibilityRule>();
    $hasSubRules = computed(() => this.eligibility().args?.length > 0);
    $badgeProps = computed<BadgeProps>(() => {
      const { result } = this.eligibility();
      if (this.$hasSubRules()) {
          return {
              variant: 'ghost'
          };
      }

      return {
          variant: result ? 'success' : 'warning',
          icon: result ? 'check' : 'close'
      };

  });


}
